import React from 'react';
import './TestResultsSpinner.css';

function TestResultsSpinner() {
  return <div className='test-results-loader'>Loading</div>;
}
export default TestResultsSpinner;
